import { camelCase } from 'lib/utils/objectSerializer';

const defaultState = {
  isLoading: true,
  error: undefined,
  reviews: [],
  cursor: { currentPage: 1 },
  previousCursor: { currentPage: 1 },
  totalReviews: 0,
  repliesCount: 0,
  key: undefined,
};

const reducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case 'RESET_REVIEWS':
      return defaultState;

    case 'FETCH_REVIEWS_REQUEST': {
      const hasFilterChanged = state.key !== action.extra.key;

      return {
        ...state,
        isLoading: true,
        error: undefined,
        key: action.extra.key,
        reviews: hasFilterChanged ? [] : state.reviews,
      };
    }

    case 'FETCH_REVIEWS_SUCCESS': {
      const reviews = action.payload.reviews
        ? action.payload.reviews.map((review) => ({
            orderId: review.order_uuid,
            date: review.created_at,
            comment: review.rating_comment,
            stars: review.rating_stars,
            reply: review.reply
              ? {
                  content: review.reply.content,
                  orderId: review.reply.order_uuid,
                  status: review.reply.status,
                  authorName: review.reply.author_name,
                  createdAt: review.reply.created_at,
                }
              : null,
          }))
        : [];

      return {
        ...state,
        isLoading: false,
        totalReviews: action.payload.total_reviews,
        repliesCount: action.payload.replies_count,
        key: action.extra.key,
        // Dedupe to ensure we only store unique order reviews
        reviews: [...state.reviews, ...reviews].reduce(
          (arr, review) =>
            !arr.some(({ orderId }) => orderId === review.orderId)
              ? [...arr, review]
              : arr,
          [],
        ),
      };
    }

    case 'FETCH_REVIEWS_FAILURE':
    case 'SUBMIT_REVIEW_RESPONSE_FAILURE':
      return {
        ...state,
        isLoading: false,
        error: action.payload.errors
          ? {
              status: action.status,
              errors: Object.values(action.payload.errors).map(
                (error) => error[0],
              ),
            }
          : camelCase(action.payload),
      };

    case 'SET_REVIEWS_CURSOR': {
      const getPreviousCursor = (cursor) => {
        if (!cursor) {
          return defaultState.cursor;
        }

        const index = Math.max(0, (cursor.currentPage - 1) * 6 - 6);
        const previous = state.reviews[index];

        return {
          id: previous.orderId,
          date: previous.date,
          currentPage: cursor.currentPage - 1,
        };
      };

      return {
        ...state,
        cursor: action.cursor,
        previousCursor: getPreviousCursor(action.cursor),
      };
    }

    case 'SUBMIT_REVIEW_RESPONSE_REQUEST':
      return {
        ...state,
        isLoading: true,
      };

    case 'SUBMIT_REVIEW_RESPONSE_SUCCESS':
      return {
        ...state,
        isLoading: false,
      };

    default:
      return state;
  }
};

export default reducer;
